import AOS from 'aos';

export default function aos() {
  
  AOS.init({});
  
}



// WEBPACK FOOTER //
// ./scripts/modules/aos.js